export enum HelpTypeEnum {
  Basics,
  All,
  Shortcuts,
}
